var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loadingData)?_c('q-checkbox',_vm._g(_vm._b({attrs:{"dense":""}},'q-checkbox',_vm.$attrs,false),_vm.$listeners)):_c('div',{staticClass:"q-py-xs"},[_c('q-skeleton',{attrs:{"type":"QCheckbox","height":"32px","animation":"fade"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }